import { ModelEvent } from 'src/broadcast/Events';
import { RequestUpdatedByEditorBroadcast } from './RequestUpdatedByEditorEvent.types';

class RequestUpdatedByEditorEvent extends ModelEvent<RequestUpdatedByEditorBroadcast> {
  public namespace = '.App\\Events\\Request\\RequestUpdatedByEditor';
}

export default RequestUpdatedByEditorEvent;
